import React, { FC } from 'react'
import { PrimeDialog } from '@ui/Dialog'
import { ModalConfig } from '@typescript'
import { ZinIconButton } from '@tnl/zin-react'
import './Modal.scss'

interface ModalProps {
  id: string
  title?: string
  children: React.ReactNode
  backdrop?: boolean
  closable?: boolean
  config?: ModalConfig
  visible: boolean
  onClose: () => void
}

const Modal: FC<ModalProps> = ({ id, title, children, backdrop, closable, config, visible, onClose }) => {
  const header = (
    <div className="mk-modal__header">
      <h2 className="title-2">{title}</h2>
      <ZinIconButton
        aria-label="Close"
        icon="xmark"
        onClick={onClose}
        set="far"
        size="lg"
      />
    </div>
  )

  return (
    <PrimeDialog
      className={['mk-modal', config?.registerShell ? 'mk-modal--register-shell' : ''].filter(Boolean).join(' ')}
      key={id}
      closable={closable ?? true}
      visible={visible}
      onHide={() => onClose()}
      modal={backdrop}
      maskStyle={{ zIndex: backdrop ? 11029 : 1 }}
      header={header}
      ptOptions={{ mergeSections: false, mergeProps: false }}
      pt={config}>
      {children}
    </PrimeDialog>
  )
}

export default Modal
